import React from 'react';
import { NavLink } from 'react-router-dom';
import { useMe } from '@/context/MeContext';

const LINKS = [
  { to: '/admin/billing', label: 'Dashboard', end: true },
  { to: '/admin/billing/plans', label: 'Plans' },
  { to: '/admin/billing/subscriptions', label: 'Subscriptions' },
  { to: '/admin/billing/payments', label: 'Payments' },
  { to: '/admin/billing/organizations', label: 'Organizations' },
  { to: '/admin/billing/revenue', label: 'Revenue', revenue: true },
  { to: '/admin/billing/attention', label: 'Attention', platformOnly: true },
  { to: '/admin/billing/webhooks', label: 'Webhooks', platformOnly: true },
  { to: '/admin/billing/providers', label: 'Providers', platformOnly: true },
  { to: '/admin/billing/exports', label: 'Exports', exportOnly: true },
];

export default function AdminBillingNav() {
  const { me } = useMe();
  const perms = me?.permissions;
  const isPlatform =
    me?.role === 'owner' || me?.role === 'platform_admin' || me?.role === 'admin';

  const visible = LINKS.filter((link) => {
    if (link.revenue && !perms?.canViewAdminRevenue) return false;
    if (link.exportOnly && !perms?.canExportAdminBilling) return false;
    if (link.platformOnly && !isPlatform) return false;
    return true;
  });

  return (
    <nav className="admin-billing-subnav" aria-label="Administration billing">
      <div className="admin-billing-subnav-title">Administration · Billing</div>
      <div className="admin-billing-subnav-links">
        {visible.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) =>
              `admin-billing-subnav-link${isActive ? ' active' : ''}`
            }
          >
            {link.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
